import { useState, useEffect } from 'react';
import axios from 'axios';

const useTeamCompetitionData = (competitionId) => {
  const [teams, setTeams] = useState([]);
  const [matches, setMatches] = useState([]);
  const [statsRequirement, setStatsRequirement] = useState('');
  const [fullRequirement, setFullRequirement] = useState('');
  const [leagueAchievements, setLeagueAchievements] = useState([]);  // ← DODANE
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [relegationProbs, setRelegationProbs] = useState({}); // Nowy stan

  useEffect(() => {
    const fetchTeamCompetitionData = async () => {
      try {
        console.log('Fetching team competition data for competitionId:', competitionId);
        setLoading(true);
		console.log('Wysyłam żądanie do /api/league/[compId]');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/league/${competitionId}`);
        const { teams: teamData, matches: matchData, leagueAchievements, statsRequirement, fullRequirement, relegationProbs: probsData } = response.data;  // ← DODANE leagueAchievements

        console.log('Teams:', teamData);
        console.log('Matches:', matchData);
		console.log('League Achievements:', leagueAchievements);
		console.log('statsReq:', statsRequirement);
		console.log('fullReq:', fullRequirement);
		setRelegationProbs(probsData || {}); // ← ZAPISUJEMY
        setTeams(teamData);
        setMatches(matchData);
		setLeagueAchievements(leagueAchievements || []);  // ← DODANE
		setStatsRequirement(statsRequirement);
		setFullRequirement(fullRequirement);
      } catch (err) {
        setError('Błąd podczas pobierania danych tabeli ligi: ' + err.message);
        console.error('Error fetching team competition data:', err);
      } finally {
        setLoading(false);
        console.log('Finished fetching team competition data, loading:', false);
      }
    };

    if (competitionId) {
      fetchTeamCompetitionData();
    } else {
      console.log('No competitionId provided, skipping fetch');
      setLoading(false);
    }
  }, [competitionId]);

return { teams, matches, leagueAchievements, relegationProbs, statsRequirement, fullRequirement, loading, error };  // ← DODANE leagueAchievements
};

export default useTeamCompetitionData;